export default [
  {
    path: '/request-partner',
    name: 'request-partner-list',
    props: true,
    component: () => import('@/views/requestPartner/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Demandes de partenariat',
      pageDesc: 'Gestion centralisée des demandes de partenariat logistique. Consultez, filtrez, et traitez les demandes de nouveaux partenaires pour la plateforme.',
      breadcrumb: [
        {
          text: 'Partenaires',
          to: { name: 'request-partner-list' },
        },
        {
          text: 'Demandes de partenariat',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Liste des demandes de partenariat logistique',
        description: 'Page accessible pour la gestion des demandes de partenariat. Utilisez les filtres, la recherche et les actions pour traiter chaque demande.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
]
